import {
  Component,
  OnInit,
} from "@angular/core";

@Component({
  selector: "app-referral-program",
  templateUrl: "./referral-program.component.html",
  styleUrls: ["./referral-program.component.scss"],
  standalone: true,
})
export class ReferralProgramComponent implements OnInit {
  constructor(
  ) {}

  ngOnInit(): void {
  }
} 